import './components/jquery';
import './components/menu-nav';
import './components/mask';
import './components/lgpd';
import './components/rangeInputs';
import './components/swiper';
import './components/video';
import './components/modal-video';